export default __webpack_public_path__ + "static/media/edit_green_icon.947a32d2.svg";